import React, { useRef } from "react";
import { throttle } from "throttle-debounce";
import styled from "styled-components";
import SanityImage from "../SanityImage";

const Carousel = styled.div`
  cursor: ew-resize;
`;
const Slide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  &:first-child {
    opacity: 1;
  }
`;

const CarouselMouseMove = ({ input }) => {
  // console.log(input);
  const carouselRef = useRef();
  const imagesLength = input.length;

  // const _onMouseMouveDebounce = debounce(200, false, e => {
  //   _onMouseMouve(e);
  // });
  const _onMouseMouveThrottle = throttle(200, false, e => {
    _onMouseMouve(e);
  });

  const _onMouseMouve = e => {
    // console.log(e);
    // return;
    const { left, width } = carouselRef.current.getBoundingClientRect();
    const part = width / imagesLength;
    const x = e.clientX - left;
    const idx = Math.ceil(x / part) >= 0 ? Math.ceil(x / part) : 0;
    const slides = carouselRef.current.querySelectorAll(".slide");
    slides.forEach(el => {
      const opacity = parseFloat(el.dataset.index) === idx ? 1 : 0;
      el.style.opacity = opacity;
    });
    // console.log(idx, imagesLength);
  };
  return (
    <Carousel
      className='carousel-mouse-move'
      role='button'
      tabIndex={-1}
      ref={carouselRef}
      onMouseMove={_onMouseMouveThrottle}>
      {input.map((el, i) => (
        <Slide className='slide tar' key={i + 1} data-index={i + 1}>
          <SanityImage input={el} />
        </Slide>
      ))}
    </Carousel>
  );
};

export default CarouselMouseMove;
